export default __webpack_public_path__ + "static/media/02_Digital_Photography Guidelines.fd9d0763.pdf";